export default __webpack_public_path__ + "static/media/18.be80c2a4.png";